import API from "../../utils/endpoints";
import * as types from "./actionType";
import history from "../../history";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const errorMessage = {
  status: 400,
  message: "Something went wrong",
};

function fetchingAllDealer() {
  return {
    type: types.FETCH_ALL_DEALER,
  };
}

function fetchingAllDealerSuccess(payload, count) {
  return {
    type: types.FETCH_ALL_DEALER_SUCCESS,
    payload,
    count,
  };
}

function fetchingAllDealerFailed() {
  return {
    type: types.FETCH_ALL_DEALER_FAILED,
  };
}

function fetchingCountry() {
  return {
    type: types.FETCH_COUNTRY,
  };
}

function fetchingCountrySuccess(payload) {
  return {
    type: types.FETCH_COUNTRY_SUCCESS,
    payload,
  };
}

function fetchingCountryFailed() {
  return {
    type: types.FETCH_COUNTRY_FAILED,
  };
}

function fetchingState() {
  return {
    type: types.FETCH_STATE,
  };
}

function fetchingStateSuccess(payload) {
  return {
    type: types.FETCH_STATE_SUCCESS,
    payload,
  };
}

function fetchingStateFailed() {
  return {
    type: types.FETCH_STATE_FAILED,
  };
}

function fetchingCity() {
  return {
    type: types.FETCH_CITY,
  };
}

function fetchingCitySuccess(payload) {
  return {
    type: types.FETCH_CITY_SUCCESS,
    payload,
  };
}

function fetchingCityFailed() {
  return {
    type: types.FETCH_CITY_FAILED,
  };
}

function creatingBranch() {
  return {
    type: types.CREATE_BRANCH,
  };
}

function creatingBranchSuccess(payload) {
  return {
    type: types.CREATE_BRANCH_SUCCESS,
    payload,
  };
}

function creatingBranchFailed() {
  return {
    type: types.CREATE_BRANCH_FAILED,
  };
}

function fetchingSingleDealer() {
  return {
    type: types.FETCH_SINGLE_DEALER,
  };
}

function fetchingSingleDealerSuccess(payload) {
  return {
    type: types.FETCH_SINGLE_DEALER_SUCCESS,
    payload,
  };
}

function fetchingSingleDealerFailed() {
  return {
    type: types.FETCH_SINGLE_DEALER_FAILED,
  };
}

function fetchingDealerBranch() {
  return {
    type: types.FETCH_DEALER_BRANCH,
  };
}

function fetchingDealerBranchSuccess(payload) {
  return {
    type: types.FETCH_DEALER_BRANCH_SUCCESS,
    payload,
  };
}

function fetchingDealerBranchFailed() {
  return {
    type: types.FETCH_DEALER_BRANCH_FAILED,
  };
}

function fetchingCountryBranch() {
  return {
    type: types.FETCH_COUNTRY_BRANCH,
  };
}

function fetchingCountryBranchSuccess(payload) {
  return {
    type: types.FETCH_COUNTRY_BRANCH_SUCCESS,
    payload,
  };
}

function fetchingCountryBranchFailed() {
  return {
    type: types.FETCH_COUNTRY_BRANCH_FAILED,
  };
}

function fetchingStateBranch() {
  return {
    type: types.FETCH_STATE_BRANCH,
  };
}

function fetchingStateBranchSuccess(payload) {
  return {
    type: types.FETCH_STATE_BRANCHSUCCESS,
    payload,
  };
}

function fetchingStateBranchFailed() {
  return {
    type: types.FETCH_STATE_BRANCHFAILED,
  };
}

function fetchingCityBranch() {
  return {
    type: types.FETCH_CITY_BRANCH,
  };
}

function fetchingCityBranchSuccess(payload) {
  return {
    type: types.FETCH_CITY_BRANCHSUCCESS,
    payload,
  };
}

function fetchingCityBranchFailed() {
  return {
    type: types.FETCH_CITY_BRANCHFAILED,
  };
}

function clearingPreviousReducer() {
  return {
    type: types.CLEAR_PREVIOUS_REDUCERS,
  };
}

//****** clearPreviousReducer  ********//

export const clearPreviousReducer = (payload) => async (dispatch) => {
  dispatch(clearingPreviousReducer());
};
//****** Fetching Dealer  ********//

export const fetchAllDealer = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingAllDealer());
  try {
    let response = await api.get(
      `${API.fetchAllDealer}?page=${payload.page}&country=${payload.country}&state=${payload.state}&city=${payload.city}&emailId=${payload.emailId}&phone=${payload.phone}&branchCode=${payload.branchCode}&dealerName=${payload.dealerName}&limit=${payload.limit}`
    );

    if (response.data.code === 200) {
      dispatch(
        fetchingAllDealerSuccess(response.data.data, response.data.count)
      );
    } else {
      dispatch(fetchingAllDealerFailed());
    }
  } catch (error) {
    dispatch(fetchingAllDealerFailed(errorMessage));
  }
};

//****** Fetching Country  ********//

export const fetchCountry = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingCountry());
  try {
    let response = await api.get(API.fetchCountry);
    if (response.data.code === 200) {
      dispatch(fetchingCountrySuccess(response.data.data));
    } else {
      dispatch(fetchingCountryFailed());
    }
  } catch (error) {
    dispatch(fetchingCountryFailed(errorMessage));
  }
};

//****** Fetching State  ********//

export const fetchState = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingState());
  try {
    let response = await api.get(`${API.fetchDealerState}?country=${payload}`);

    if (response.data.code === 200) {
      dispatch(fetchingStateSuccess(response.data.data));
    } else {
      dispatch(fetchingStateFailed());
    }
  } catch (error) {
    dispatch(fetchingStateFailed(errorMessage));
  }
};

//****** Fetching City  ********//

export const fetchCity = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingCity());
  try {
    let response = await api.get(
      `${API.fetchDealerCity}?country=${payload.countryCode}&stateName=${payload.state} `
    );

    if (response.data.code === 200) {
      dispatch(fetchingCitySuccess(response.data.data));
    } else {
      dispatch(fetchingCityFailed());
    }
  } catch (error) {
    dispatch(fetchingCityFailed(errorMessage));
  }
};

//****** Creating Branch  ********//

export const createBranch = (payload) => async (dispatch, getState, api) => {
  dispatch(creatingBranch());
  try {
    let response = await api.post(API.createBranch, payload.formData);
    if (response.data.code === 200) {
      dispatch(creatingBranchSuccess(response.data.data));
      history.push(`/dealer/detail?dealerId=${payload.id}&tab=${payload.tab}`);
      toast.error(response.data.message);
    } else {
      dispatch(creatingBranchFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(creatingBranchFailed(errorMessage));
  }
};

//****** fetch Single Dealer  ********//

export const fetchSingleDealer = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingSingleDealer());
  try {
    let response = await api.get(
      `${API.fetchSingleDealer}?dealerId=${payload}`
    );
    if (response.data.code === 200) {
      dispatch(fetchingSingleDealerSuccess(response.data.data));
    } else {
      dispatch(fetchingSingleDealerFailed());
    }
  } catch (error) {
    dispatch(creatingBranchFailed(errorMessage));
  }
};

//****** fetch Dealer Branch  ********//

export const fetchDealerBranch = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingDealerBranch());
  try {
    let response = await api.get(
      `${API.fetchDealerBranch}?dealerId=${payload}`
    );

    if (response.data.code === 200) {
      dispatch(fetchingDealerBranchSuccess(response.data.data));
    } else {
      dispatch(fetchingDealerBranchFailed());
    }
  } catch (error) {
    dispatch(creatingBranchFailed(errorMessage));
  }
};

//****** Fetching CountryBranch  ********//

export const fetchCountryBranch = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingCountryBranch());
  try {
    let response = await api.get(API.fetchCountryBranch);
    if (response.data.code === 200) {
      dispatch(fetchingCountryBranchSuccess(response.data.data));
    } else {
      dispatch(fetchingCountryBranchFailed());
    }
  } catch (error) {
    dispatch(fetchingCountryBranchFailed(errorMessage));
  }
};

//****** Fetching State Branch ********//

export const fetchStateBranch = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingStateBranch());
  try {
    let response = await api.get(`${API.fetchStateBranch}?country=${payload}`);

    if (response.data.code === 200) {
      dispatch(fetchingStateBranchSuccess(response.data.data));
    } else {
      dispatch(fetchingStateBranchFailed());
    }
  } catch (error) {
    dispatch(fetchingStateBranchFailed(errorMessage));
  }
};

//****** Fetching City Branch ********//

export const fetchCityBranch = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingCityBranch());
  try {
    let response = await api.get(
      `${API.fetchCityBranch}?country=${payload.countryCode}&state=${payload.state}`
    );

    if (response.data.code === 200) {
      dispatch(fetchingCityBranchSuccess(response.data.data));
    } else {
      dispatch(fetchingCityBranchFailed());
    }
  } catch (error) {
    dispatch(fetchingCityBranchFailed(errorMessage));
  }
};

